module.exports = __webpack_public_path__ + "static/media/extrasmellydurian.fe5d138d.webp";